import React, { useEffect,useState } from "react";
import JdsPriority from "../../jdsPriority";

export default function NuJobsJDsPriority(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <JdsPriority product = {"nujobs"}/>
    </div>  
  );
}
